<ng-container>
  <app-mp-camera [facingMode]="facingMode" [numberOfPictures]="1" [isLoanLiveliness]="true" (proceed)="callback($event)" (cancel)="modalService.destroy()">
  </app-mp-camera>
</ng-container>